export default function useHyperlinkParser() {
  return { convertHyperlink }

  function convertHyperlink(text: string) {
    // Regular expression to detect URLs with or without "http", "https", or "www"
    const urlRegex =
      /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g

    // Split the text into parts based on the URL pattern
    const parts = text.split(urlRegex)

    return parts.map((part, index) => {
      if (urlRegex.test(part)) {
        // If the part is a URL, add "https://" if missing or "www" is missing
        let href = part
        if (!part.startsWith('http') && !part.startsWith('www')) {
          // If it's a domain name without http or www, add "https://"
          href = `https://${part}`
        } else if (part.startsWith('www')) {
          // If it starts with "www", prepend "https://"
          href = `https://${part}`
        }

        return (
          <a href={href} target="_blank" rel="noopener noreferrer" key={index}>
            {part}
          </a>
        )
      }
      // Return the part as plain text if it's not a URL
      return part
    })
  }
}
